<template>
    <div id="ContainerDailyNote">
        <div class="page-height">
            <div class="col-12">
                <MdTitleRegInfo v-if="!UseViewAllReadOnly"
                    v-bind:RegistrationInfo="isShedulerDB ? PatientTitle : RegistrationInfo" 
                    v-bind:titlePrefix="this.Mode ? $t('Medication.Edit') : $t('Medication.Add')" 
                    v-bind:titleRef="'titleElementMedication'"
                    v-bind:patientCode="this.$route.params.id || this.PCode">
                </MdTitleRegInfo>
                
                <b-row>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientAllergies
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddAllergy="'AddAllergyMed'"
                            v-bind:VisibleAllergy="true"                    
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'auto'"                   
                            v-bind:PatientCode="this.$route.params.id || this.PCode"
                            v-bind:NoValidateChanges="true">						
                        </MdPatientAllergies>
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientSpecialPrecautions	
                            v-bind:NoUseClass="false" 
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddSpecialPrecautions="'AddSpecialPrecautionMed'"                   
                            v-bind:VisibleSpecialPrecautions="true"
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'auto'"
                            v-bind:PatientCode="this.$route.params.id || this.PCode"
                            v-bind:NoValidateChanges="true">						
                        </MdPatientSpecialPrecautions>        
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientMarsAlert 	
                            v-bind:NoUseClass="false" 
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddMarksAlert="'AddMarsAlertsMed'"
                            v-bind:VisibleMarsAlert="true"                   
                            v-bind:UseColumnDynamic="true"
                            v-bind:Column="'auto'"
                            v-bind:PatientCode="this.$route.params.id || this.PCode"
                            v-bind:NoValidateChanges="true">						
                        </MdPatientMarsAlert>
                    </b-col>
                </b-row>

            <MdTitle v-bind:VisibleInfo="false" v-bind:ReadOnlyInfo="Medication.drugCode === null || Medication.drugCode === '' " v-bind:VisibleChat="useMerative" @ClickInfo="ClickInfo" @ClickChat="ClickChat" v-bind:Text="CreatedBy" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly && Medication.canEditMessage">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ Medication.canEditMessage }}</span>
                    </div>
                </div>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="Medication.pharmacistNotes">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{$t('Medication.PharmacistNotes') +': '+Medication.pharmacistNotes}}</span>
                    </div>
                </div>
                
                <b-row>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.Prescriber')"
                            v-bind:Options="PrescriberList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="false"
                            v-bind:Model="ModelPrescriber"    
                            v-bind:Multiple="false"  
                            v-bind:isRequired="true"                            
                            v-bind:isValid="isPrescriberValid"                              
                            :Input="ChangeDropDownPrescriber"
                            v-bind:FeedBackText="$t('Insurance.InsuranceTypeRequired')"
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12" v-if="!this.PharmacyOption.byPassPhysicianSignature">
                        <MdCheckBox
                            v-bind:Label="$t('MdNote.Sign')"
                            v-bind:Name="'checkboxAdd-Sign'" 
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"              
                            v-model="isSigned"
                            v-on:change="onSignature"
                            v-bind:Tag="'SignMedication'"  
                            :isReadOnly="UseViewAllReadOnly || isReadOnly || Medication.rxStatus == 'VOID' || Medication.isSigned || internalStatusReadOnly"  
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <div class="d-flex align-items-center w-100">
                            <div class="flex-grow-1">
                            <MdLookupMultiple
                                v-bind:ModelCode="Medication.drugCode"
                                v-bind:ModelDescription="Medication.drugName"
                                v-bind:Label="$t('Medication.Drugs')"                             
                                v-bind:RefCode="'Drugs'"  
                                v-bind:Api="DrupNameCall"
                                v-bind:OptionParamList="ParamList"                                                   
                                v-bind:FieldCode="'code'"   
                                v-bind:modelFilter="modelFilter"                         
                                v-bind:FieldDescription="'drugName'"
                                :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"   
                                v-bind:isValid="this.isDrugValid"
                                :InvalidFeedback="this.TextDrugs"                            
                                v-bind:isRequired="true"      
                                :ChangeFilter="ChangeFilter"                         
                                :SearchTitle="$t('Medication.Drugs')"
                                :GetValues="onCodeConditionOk"                     
                                :SearchFieldCode="'Code'"
                                v-bind:Fields="BaseFieldsDrug"
                            />
                            </div>
                            <div class="d-flex justify-content-end px-0">
                            <i v-on:click="ClickInfo" class="ikon med-help h3 ms-2 mt-4 extraIcon" v-b-tooltip.hover :title="$t('Medication.QuestionMark')"></i>
                            </div>
                        </div>
                        </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.Usage')"
                            v-bind:Options="UsageList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="false"
                            v-bind:Model="Medication.usage"    
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownUsage"
                            :IsDisabled="isReadOnly || usageIsReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />
                    </b-col>             
                </b-row>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Medication.Days')"
                            v-bind:Name="'Days'"
                            v-bind:TypeProp="'number'"                      
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDayValid"
                            :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                            v-model.number="Medication.day"
                            v-on:blur="OnBlurDay($event)"
                            v-on:change="onChangeDay($event)"
                            v-bind:isReadOnly="isReadOnly || frecuencyMode === 'STAT' || internalStatusReadOnly || UseViewAllReadOnly"
                        />   
                    </b-col>    
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Medication.Dosage')+unitOfMeasure"
                            v-bind:Name="'Dosage'"
                            v-bind:TypeProp="'number'"                      
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDosageValid"
                            :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                            v-model.number="Medication.dosage"
                            v-on:change="onChangeDosage($event)"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />   
                    </b-col>  
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Medication.DailyAmount')+unitOfMeasure"
                            v-bind:Name="'DailyAmount'"
                            v-bind:TypeProp="'number'"                      
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDailyAmountValid"
                            :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                            v-on:change="onChangeDailyAmount($event)"               
                            v-model.number="Medication.dailyAmount"              
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />  
                    </b-col> 
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Medication.TotalQty')"
                            v-bind:Name="'totalqty'"
                            v-bind:TypeProp="'number'"                      
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-model.number="Medication.quantityOrdered"
                            v-bind:isReadOnly="true"
                        />   
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Medication.StartDateAndTime')"
                            v-bind:Name="'sDate'"
                            v-bind:TypeProp="'text'" 
                            v-bind:Mask="'##/##/#### ##:## AA'"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isStartTimeValid"
                            v-model="startDateTime"
                            v-on:change="onChangeStartDateTime($event)"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />   
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Medication.EndDateAndTime')"
                            v-bind:Name="'eDate'"
                            v-bind:TypeProp="'text'" 
                            v-bind:Mask="'##/##/#### ##:## AA'"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isEndTimeValid"
                            v-model="endDateTime"
                            v-on:change="onChangeEndDateTime($event)"               
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                    />   
                    </b-col> 
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.RxStatus')"
                            v-bind:Options="RxStatusList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'value'"
                                v-bind:AllowEmpty="false"
                            v-bind:Model="Medication.rxStatus"    
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownRxStatus"
                            :IsDisabled="isReadOnly || UseViewAllReadOnly"
                        />
                    </b-col> 
                    <b-col v-if="Medication.rxStatus == 'Inactive'"  md="3" lg="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Medication.stopDateTime')"
                            v-bind:Name="'eDate'"
                            v-bind:TypeProp="'text'" 
                            v-bind:Mask="'##/##/#### ##:## AA'"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"
                            v-model="Medication.stopDateTime"
                            v-on:change="onChangeStopDateTime($event)"               
                            v-bind:isReadOnly="isReadOnly || UseViewAllReadOnly"
                        />   
                    </b-col>                           
                </b-row>            

                <b-row>   
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="Medication.frequencyCode"
                            v-bind:ModelDescription="Medication.frequencyDescription"
                            v-bind:Label="$t('Shared.Frequency')"
                            v-bind:RefCode="'Frequency'"  
                            v-bind:AuxFields="this.FrequencyAuxFields"                     
                            v-bind:Api="'DrugFrequencyHeaders?AdministrationFrequencies=true'"
                            v-bind:FieldCode="'code'"  
                            v-bind:isValid="isFrequencyValid"
                            v-bind:isRequired="true"                         
                            v-bind:FieldDescription="'description'"
                            :InvalidFeedback="this.TextFrequency"    
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"    
                            :SearchTitle="$t('Shared.Frequency')"
                            :GetValues="onCodeConditionOk"                     
                            :SearchFieldCode="'Code'"
                            v-bind:Fields="BaseFields"
                        />
                    </b-col>     
                    <b-col lg="3" md="3" sm="12">
                        <MdButton
                            v-bind:Label="$t('Medication.Dosage-Time')"
                            v-bind:isReadOnly="(Medication.frequencyCode && (Medication.dosage || Medication.dailyAmount) && frecuencyMode !== 'STAT' && frecuencyMode !== 'PRN') && !internalStatusReadOnly ? false : true"
                            v-bind:Name="'btn_dosagetime'"
                            v-bind:ClassProp="'secondary mt-3 btn-login'"
                            v-on:click="OpenDosageTime"/>                    
                    </b-col> 
                    <b-col md="3" lg="3" sm="12" v-if="!isNRC">
                        <MdCheckBox
                            v-bind:Label="$t('Medication.PatientOwned')"
                            v-bind:Name="'patientowned'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                            v-model="Medication.isPatientOwnMedication"
                            v-on:change="onChangePatientOwned"
                            v-bind:Tag="'SignMed'"
                        />
                    </b-col>   
                </b-row>  

                <MdTitle v-bind:Text="$t('Medication.Sig')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$tc('Shared.ActionsTxt')"
                            v-bind:Options="ActionList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelAction"    
                            v-bind:Multiple="false"  
                            v-bind:isRequired="PharmacyOption.enforceSigAction" 
                            v-bind:FeedBackText="$t('Medication.ActionRequired')" 
                            v-bind:isValid="isActionValid"
                            :Input="ChangeDropDownAction"
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.RouteN')"
                            v-bind:Options="RouteNameList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelRoute"  
                            v-bind:isRequired="PharmacyOption.enforceSigRoute" 
                            v-bind:FeedBackText="$t('Medication.RouteRequired')" 
                            v-bind:isValid="isRouteValid"  
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownRouteName"
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.When')"
                            v-bind:Options="WhenList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelWhen"    
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownWhen"
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.Reason')"
                            v-bind:Options="ReasonList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelReason"  
                            v-bind:isRequired="this.PharmacyOption.enforceSigReasonPRN && this.frecuencyMode === 'PRN'" 
                            v-bind:FeedBackText="$t('Medication.ReasonRequired')" 
                            v-bind:isValid="isReasonValid"  
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownReason"
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />
                    </b-col>
                </b-row> 

                <b-row>
                    <b-col md="12" lg="12">
                        <MdMemo
                            v-bind:Name="'textarea_notes'"
                            v-bind:Rows="'3'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-model="Medication.sig"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />                                     
                    </b-col>
                </b-row>


                <div v-if="this.$store.state.companies.isUAE">
                    <MdTitle v-bind:Text="$t('Medication.SigArabic')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                    <b-row>
                    <b-col md="12" lg="12">
                        <MdMemo
                            v-bind:Name="'textarea_notesArabic'"
                            v-bind:Rows="'3'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-model="Medication.sigTranslated"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />                                     
                    </b-col>
                </b-row>
                </div>


                <MdTitle v-bind:Text="$t('Medication.PrescriberNotes')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            
                <b-row>
                    <b-col md="12" lg="12">
                        <MdMemo
                            v-bind:Name="'textarea_notes'"
                            v-bind:Rows="'3'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-model="Medication.prescriberNotes"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"
                        />                                     
                    </b-col>
                </b-row> 
            
                <MdTitle v-bind:BlankDescription="$t('Shared.Diagnosis')" v-bind:Text="$t('Medication.DiagnosisAndIndication')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>                         
            
                <b-row>
                    <b-col lg="3" md="3" sm="12">                       
                        <MdSelect
                            v-bind:Label="$t('Shared.Diagnoses')"
                            v-bind:Options="DiagnosisList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelDiagnosis"                          
                            v-bind:isRequired="PharmacyOption.enforceDiagnosis" 
                            v-bind:FeedBackText="$t('Medication.DiagnosisRequired')" 
                            v-bind:isValid="isDiagnosisValid"    
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownDiagnosis"
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"               
                        /> 
                    </b-col> 
                    <b-col cols="auto" class="mt-3">
                          <MdButton
                            v-bind:Label="$t('Medication.AddDiagnoses')"
                            v-bind:Name="'btn_AddDiag_medications'"
                            v-bind:ClassProp="'secondary mx-2 btn-login'"
                            v-on:click="OpenDiagnosis"/>
                    </b-col>      
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.Indications')"
                            v-bind:Options="IndicationsList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelIndication"    
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownIndication"
                            :IsDisabled="isReadOnly || internalStatusReadOnly || UseViewAllReadOnly"               
                        />
                    </b-col> 
                </b-row>
            </div>

            <div class="space-actions"></div>
            
            <div class="page-actions" v-if="!UseViewAllReadOnly">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btn_list_medications'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"/>

                <MdButton v-if="!this.Mode"
                    v-bind:Label="$t('Shared.Save')"
                    style="z-index:99999"
                    v-bind:ClassProp="'primary btn-login mx-2'"
                    v-on:click="SaveOrEdit"                
                    v-bind:isReadOnly="!this.pendingChanges"               
                    v-bind:Name="'btn_save_medications'">
                </MdButton>

                <b-button-group variant="primary" v-if="this.Mode">
                    <b-button :disabled="!this.pendingChanges" variant="primary" v-on:click="SaveOrEdit">{{$t('Shared.Save')}}</b-button>
                    <b-dropdown variant="primary" class="ms-2">
                        <b-dropdown-item v-on:click="CopyOrder()" v-if="this.Mode && !isReadOnly"> {{$t('Medication.CopyOrder')}}</b-dropdown-item>
                        <b-dropdown-item v-on:click="CopyDCOrder()" v-if="this.Mode && this.Medication.rxStatus != 'Inactive' && !isReadOnly">{{$t('Medication.CopyDCOrder')}}</b-dropdown-item>
                        <b-dropdown-item v-on:click="InactiveOrders()"  v-if="this.setVisibilityInactiveOrder() && !isReadOnly">{{$t('Medication.InactiveOrder')}}</b-dropdown-item>
                        <b-dropdown-item v-on:click="showReport" v-if="this.Mode">{{ $t('Shared.Report') }}</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </div>
        </div>
        
        <BaseModal v-if="VisibleModal"
                ModalId="'ModalIdDosageTime'"
                :HideModalFun="HideModal"
                :TitleWindow="$t('Medication.TitleModalDosageTime')"
                :width="'30%'"
                :height="'auto'"
                :buttons="[
                    { text: 'Cancel', variant: 'secondary', action: 'Close' },
                    { text: 'Ok', variant: 'primary', action: handleOk },                   
                ]"              
                @Close="Close"
              >
              <form ref="form" @submit.stop.prevent="handleSubmit">
     <div v-for="(item,index) in marsTimes" :key="index">
      <b-row>
          <b-col lg="6" md="6" sm="12">
              <MdEdit 
              v-bind:Label="$t('Medication.Dosage')+unitOfMeasure"
              v-bind:Name="'Days'"
              v-bind:TypeProp="'number'"  
              v-bind:isReadOnly="isReadOnly || UseViewAllReadOnly"                    
              v-bind:Min="'1'"
              v-bind:Max="'1000'"
              v-model.number="item.dosage"             
            />   
          </b-col> 
          <b-col md="6" lg="6" sm="12">
            <MdEdit 
                v-bind:Label="$t('Medication.Time')"
                v-bind:TypeProp="'time'"             
                v-bind:Name="'adminTime'"
                v-bind:isReadOnly="isReadOnly || UseViewAllReadOnly"      
                v-model="item.adminTime"                        
                v-on:change="ChangeTime">                                 
            </MdEdit>
        </b-col>   
        </b-row>
     </div>
     </form>          
        </BaseModal>






        <PatientMedicationsRep v-if="isReportVisible" 
            :closeWindow="closeParamRepWindow"
            :patientCode="this.$route.params.id || this.PCode"
            :recNo="recNoToReport"
        />

        <MdPasswordDlg v-if="showSignPassword" 
            v-bind:Type="TypePassWord"
            v-bind:EmployeeCode="EmployeeCodeSelected"
            @getModalPassword="onModalPasswordResult($event)"
        />

        <MdPatientDiagCodes v-if="activateModalDiagCodes"
            v-bind:ModalId="'MedicationModalAddDiagnosis'"
            v-bind:PatientCode="PatientCode"
            v-bind:ReadOnly="isReadOnly || UseViewAllReadOnly"
            v-bind:RecordId="AdmissionRecId"           
            v-bind:TitleWindow="$t('Shared.Diagnoses')"
            @getCodeConditionOK="onOkDiag($event)"
            @getCancel="onCancel($event)"
        ></MdPatientDiagCodes>

    </div>
</template>

<script>

import ShowMessage from '@/components/messages/ShowMessage.js'
import StorageService from '@/services/storage.service'
import MedicationService from '@/services/medication.service'
import InventoryItemService from '@/services/inventoryitem.service'
import DrugFreqSetupHdrService from '@/services/drugfreqsetuphdrs.service'
import DrugFreqSetupDetService from '@/services/drugfreqsetupdet.service'
import PharmacyOptions from '@/services/pharmacyoption.service'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import EnumService from '@/services/enum.service' 
import Utils from "@/common/utils"

import moment from "moment";
import LocalStorage from '@/services/storage.service';
import GlobalService from '@/services/global.service'
import PatientService from '@/services/patient.service'
import IndicationService from '@/services/indication.service'
import EmployeeService from '@/services/employee.service'
import ProviderService from '@/services/provider.service'
import Permission from '@/common/Permission'


export default {
    /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iUA = await vm.$store.state.isUseMedications;
            if(iUA) 
                next()
            else 
                next('/accessdenied');
        }) 
    },*/

    beforeRouteLeave(to, from, next) {
	if (!this.isReadOnly && this.pendingChanges) {
		this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$t('Msg.Confirm'),
          okTitle: this.$t('Shared.BtnSave'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(async value => {
            if(!value){
              next();
            } else {
                await this.ClickOffRoute();
             var f = this.WasSaved;             
              if(f){
                  next();
              }
            
            }
          })		
	} else {
		next()
	}
    },

    mixins: [ShowMessage, DBFunctions, Permission],  
    name: 'MedicationDetails',
    props:{
        UseViewAllReadOnly:Boolean,
        UseInModal:Boolean,
        RecordId:String,
        PCode:String,
    },
    data() {
        return { 
            isActionValid:true,
            isRouteValid:true,
            isReasonValid:true,
            isNRC:this.$store.state.companies.isNRC,
            PatientCode:"",
            AdmissionRecId:"",
            activateModalDiagCodes:false,
            isDiagnosisValid:true,
            VisibleModal:false,
            useMerative:false,
            internalStatusReadOnly:false,
            isDrugValid:true,
            isPrescriberValid:true,
            isFrequencyValid:true,
            isDayValid:true,
            isDosageValid:true,
            isDailyAmountValid:true,
            isStartTimeValid:true,
            isEndTimeValid:true,
            DateandTimeUpdated:null,
            TextFrequency:this.$t('Msg.RequiredField'),
            TextDrugs:this.$t('Msg.RequiredField'),
            OffRoute:false,
            clickBack:false,
            WasSaved:false,
            isFrequencySTAT:false,
            startDateTime:null,
            endDateTime:null,
            DiagnosisList:[],
            IndicationsList:[],
            CopyDateTime:null,
            ModelAction:{code:"",description:""},
            ModelRoute:{code:"",description:""},
            ModelWhen:{code:"",description:""},
            ModelReason:{code:"",description:""},
            ModelDiagnosis:{code:"",description:""},
            ModelIndication:{code:"",description:""},
            ModelPrescriber:{code:"",name:""},         
            timesPerDay:0,
            MarsAdminTime:[],
            MarsDosage:[],
            marsTimes:[],
            unitOfMeasure:"",
            VisibleDosageTime:false,
            isReload:true, 
            CreatedBy:'',       
            Mode:this.$attrs.editMode,  
            Loading:true,
            PrescriberModel:{
                prescriberCode:"",
                prescriberName:""
            },
            isReadOnly: false,
            pendingChanges: false,
            PharmacyOption:{},
            OptionsRightMenu:{
                visible:true,
                ItemsList:[],
                btnvisible:true,
                itemdisabled: false,       
            },
            FrequencyAuxFields:['hoursBetweenDoses','mode','recurEveryDays','timesPerDay'],
            RegistrationInfo: {},
            InventoryItem:{
                DispensingQty:1,
                DispensingCapacity:1,
                Dispensinguom:"QTY",
                IsReusable:false
            },
            EmpList:[],
            dDiagnosis:"",         
            dIndications:"",
            ObjData:{},
            Medication:{
                reason:"",
                dailyAmount:0,
                patientCode:this.$route.params.id || this.PCode,
               // AdmissionRecordId:this.isShedulerDB ? this.currentAppointmentDB && this.currentAppointmentDB.recId : this.$route.params.recordid,
                AdmissionRecordId:this.isShedulerDB ? null : this.$route.params.recordid,
                frequencyCode:"",
                action:"",
                unitOfMeasure:"",
                restrictChangeDay:false,           
                dateTimeCreated: null,
                dateTimeExpired: null,
                day:1,
                diagCode:"",
                dispensingCapacity:0,
                dosage:0,
                doseQty: 0,
                drugCode:"",
                drugName:"",
                employeeCode:"",
                endDate:null,
                endTime:null,
                externalCreator: "",
                form: "",
                frequency:"",
                headerId: "",
                indicationCode:null,
                internalStatus: "",
                isInpatient: false,
                isPatientOwnMedication: false,
                isReusable: false,
                isSigned: false,
                issueType: "",
                issuedDate:null,
                medication:"",
                mode: "",
                notes: "",
                notesPlaintext:"",
                orderType: "",           
                pharmacistCode:"",
                pharmacistNotes: "",
                pharmacyAddress: "",
                pharmacyId: "",
                pharmacyName: "",
                prescriber: "",
                startDateTime:null,
                endDateTime:null,
                prescriberCode:"",
                qtytoTake:0,
                quantity: 0,
                quantityOrdered:0,
                recordId: "",
                refills:0,
                route: "",
                rxAutoStatus: "",
                rxNorm: "",
                rxStatus: "",
                rxType: "",
                showNoEndDate: false,
                showNoStartDate:false,
                sig: "",
                sigTranslated:null,
                source: "",
                sourceRecordId:"",
                startTime: null,
                stopDate: null,
                stopTime: null,
                strength:null,
                timeToTake: 0,
                transmissionStatus: "",
                unit: "",
                whenSig: "",
                stopDateTime: null,
                marsTimes:[
                ]
            },
            EnabledDosageBtn:false,
            DateNow:null,
            OrderTypeList:[],
            ReasonList:[],
            WhenList:[],
            WhenModel:"",
            PrescriberList:[],
            RouteNameList:[],
            UsageList:EnumService.ClinicalMedicationUsage,
            RxStatusList:EnumService.ClinicalMedicationRxStatus,
            ActionList:[],
            DrugDescription:"",        
            RxStatusModel:{value:'Active',name: this.$t('Shared.Active')},
            ActionModel:"",
            RouteNameModel:"",
            UsageModel:{value:'Internal',name:'Internal'},
            DrupNameCall:"PatientMedications/AllDrugs?",
            dFrequency:"",
            ParamList:[
                {
                    code:1,
                    description:this.$t('Medication.Param.AllDrugs'),
                    resource:"PatientMedications/AllDrugs?"
                },
                {
                    code:2,
                    description:this.$t('Medication.Param.DrugsHistory'),
                    resource:"PatientMedications/DrugsHistory?PatientCode="+this.$route.params.id || this.PCode
                },
                {
                    code:3,
                    description:this.$t('Medication.Param.DrugByDiag'),
                    resource:"PatientMedications/DrugsByDiagnoses?PatientCode="+this.$route.params.id || this.PCode
                },
                {
                    code:4,
                    description:this.$t('Medication.Param.PrefDrugs'),
                    resource:"PatientMedications/PreferredDrugs?"
                },
            ],

            modelFilter:{code:1,description:this.$t('Medication.Param.AllDrugs'),resource:"PatientMedications/AllDrugs?"},

            //Models
            OrderTypeModel:"",

            style:{
                boxShadow: '0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important',
                width: '100%',
                backgroundImage: '-webkit-linear-gradient(268deg, #FAFAFA, #FAFAFAEE)',
                borderRadius: '0 0 14px 14px',
                borderTop: '1px solid #EEE',
                padding: '10px',
                textAlign: 'right'     
            },

            UserId: LocalStorage.getUserId(),
            BaseFields:[
                { key: 'description', sortable: true, label: this.$t('Shared.Description')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'mode', sortable: true, label: this.$t('Medication.Mode')},
                { key: 'recurEveryDays', sortable: true, label: this.$t('Medication.ReEveryDays')},
                { key: 'timesPerDay', sortable: true, label: this.$t('Medication.TimesPerDay')},
                { key: 'hoursBetweenDoses', sortable: true, label: this.$t('Medication.HoursBetweenDoses')},
            ],
            BaseFieldsDrug:[
                { key: 'drugName', sortable: true, label: this.$t('Medication.DrugName')},
                { key: 'activeIngredients', sortable: true, label: this.$t('Medication.AcIngredients')},
                { key: 'dosage', sortable: true, label: this.$t('Medication.Dosage')},
                { key: 'form', sortable: true, label: this.$t('Medication.Form')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code')}
            ],
            isReportVisible: false,
            recNoToReport: '',
            IsPrescriptionCurrent: false,
            frecuencyMode: '',
            defaultDoctor: '',
            isShedulerDB: false,
            PatientTitle:{      
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:'',
                activitytypename:'',
                startdatetime:'',
                ageFormatted:''
            },
            currentAppointmentDB:{
                guid:'',
                activitytypecode:'',
                employee: {
                    firstname:"",
                    lastname:""
                },
            },
            EmployeeCodeSelected:"",   
            showSignPassword: false,
            isSigned:false,
            TypePassWord:"",
            ProviderModel:{
                therapistCode:"",
                therapistName:"", 
                requestSigCreateMed:false
            },
            EmployeeCode:"",
            usageIsReadOnly: false
        }
    },

    methods:{

        onCancel(){
            this.activateModalDiagCodes = false;
        },
        onOkDiag(){
            this.activateModalDiagCodes = false;
            this.getDiagnosisByPatientCode();
        },

        ChangeTime(){

        },

        HideModal(){            
            this.VisibleModal = false;
        },

        OKClick(){
            this.VisibleModal = false;
        },

        Close(){
            this.VisibleModal = false;
        },

         OpenDosageTime(){
            this.VisibleModal = true;
        },



    emitEventOK(/*bvModalEvent*/){     
      let arr = [];
      let dates = [];
      let _enddatetime = null;
      for(var i = 0; i < this.marsTimes.length; i++){
        
        arr.push(
          {
            dosage:this.marsTimes[i].dosage,           
            adminTime:moment("1899-12-30T"+this.marsTimes[i].adminTime).format('YYYY-MM-DDTHH:mm:ss')
          });

          dates.push(new Date(moment("1899-12-30T"+this.marsTimes[i].adminTime).format('YYYY-MM-DDTHH:mm:ss')));
      }
        this.SameValues();
        var max = new Date(Math.max(...dates));
        if(max){
          _enddatetime = Utils.formatTime(max, Utils.getDateTimeFormat());
        }    


        let obj = {
          marsTimes: arr,
          EndDateTime :_enddatetime
        }

        this.RefreshDosageTime(obj);
        this.VisibleModal = false;
       // this.$emit('RefreshDosageTime',obj);
       

     },

     SameValues(){
      const allEqual = (arr) =>  arr.every((val) => val.dosage === arr[0].dosage); 
      let samevalue = allEqual(this.marsTimes);
        if(!samevalue){         
          this.DosageDifferent(true);
        }

     },

     handleOk(bvModalEvt) {  
        if(!this.isReadOnly && !this.UseViewAllReadOnly){
            bvModalEvt.preventDefault();      
            this.handleSubmit()
        }else{
            this.VisibleModal = false;
        }    
        
      },

     SumDosage(){
      let sum = 0;
      for(var i = 0; i < this.marsTimes.length; i++){
        sum+=this.marsTimes[i].dosage;
      }
      return sum;
     },

     checkFormValidity() {       
         return this.SumDosage() === this.Medication.dailyAmount; 
      // return this.SumDosage() === this.DailyAmount;      
      },

      OpenDiagnosis(){
        this.activateModalDiagCodes = true;
      },

     handleSubmit() {      
        if (!this.checkFormValidity()) {
          this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.MaxDailyAmount'),"error");
          return
        }else{
          this.emitEventOK();
        }
      
      },


        DiscardChanges() {
            this.clickBack = true;
            if (this.isShedulerDB) {
                this.$router.push({
                    name: "appointmentDB-Medications",
                    params: { id: this.$route.params.id || this.PCode, actId: this.$route.params.actId },
                });
            } else {
                this.$router.push({
                    name: "Clinical-Medications",
                    params: { id: this.$route.params.id || this.PCode, recordid: this.$route.params.recordid },
                });   
            }
        },

        ClickInfo(){
            if(this.Medication.drugCode !== null && this.Medication.drugCode !== ""){
                this.getUrlDrugInfo();
            }else{
                this.showMessage(this.$tc('Msg.Warning',1),this.$t('Medication.NoDrugCode'),"warning");
            }        
          
        },

    async getUrlMerative(){       
      await MedicationService.getUrlMerative()
            .then((response) => {      
               if (response.status == '200' && response.data) {                    
                    window.open(response.data.url, '_blank');      
               }               
         })
         .catch(error => {          
            this.showResponseErrorMessage(error);              
         });    
    },

        async getUrlDrugInfo(){        
      await MedicationService.getUrlDrugInfo(this.Medication.drugCode)
            .then((response) => {      
               if (response.status == '200' && response.data) {
                    window.open(response.data.url, '_blank');      
               }               
         })
         .catch(error => {            
            this.showResponseErrorMessage(error);                
         });    
    },

        ClickChat(){
            this.getUrlMerative();
        },
    

        ChangeDropDownEmpl(){

        },

        showReport(){
            this.recNoToReport = this.$route.params.recId
            this.isReportVisible = true
        },

        ChangeDropDownOrderType(){

        },

        PrepareMedication (){
            this.ObjData = {
                PatientCode:this.$route.params.id || this.PCode,
                //AdmissionRecordId: this.isShedulerDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                AdmissionRecordId: this.isShedulerDB ? null : this.$route.params.recordid,
                PrescriberCode:this.ModelPrescriber.code,
                DrugCode:this.Medication.drugCode,
                Usage:this.Medication.usage,
                IsPatientOwnMedication:this.Medication.isPatientOwnMedication,
                Day:this.Medication.day,
                Dosage:this.Medication.dosage,
                DailyAmount:this.Medication.dailyAmount,
                QuantityOrdered:this.Medication.quantityOrdered,
                StartDateTime:Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                EndDateTime:Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                RxStatus:this.Medication.rxStatus,
                FrequencyCode:this.Medication.frequencyCode,
                Sig:this.Medication.sig,
                SigTranslated:this.Medication.sigTranslated,
                Action:this.ModelAction.code,
                Route:this.ModelRoute.code,
                WhenSig:this.ModelWhen.code,
                Reason:this.ModelReason.code,
                PrescriberNotes:this.Medication.prescriberNotes,
                DiagCode:this.Medication.diagCode,
                IndicationCode:this.Medication.indicationCode,
                StopDateTime: Utils.formatterToISO(this.Medication.stopDateTime, Utils.getDateTimeFormat()),
                MarsTimes:this.Medication.marsTimes,
                IsSigned:this.isSigned
            }
        },

        IsNullOrEmpty(value){
            return (((value??"").trim() === "") || value === null) ? true : false;
        },

       async Validate(){
        // eslint-disable-next-line no-debugger
       // debugger;      
                if(  ((this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') && (this.Medication.stopDateTime === "")  ){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.StopDateCannotbeEmpty'),"error");        
                    return false;
                }

               /* if(  ((this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') && this.Medication.stopDateTime){
                    await this.getDateTimeValidateStopDate();
                    const stopDate = moment(this.Medication.stopDateTime, Utils.getDateTimeFormat())
                    const DNow  = moment(this.DateNow, Utils.getDateTimeFormat())
                    if ( stopDate < DNow ){
                            this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.TheStopDateMustBeGreaterThanTheCurrentDate'),"error");        
                            return false;
                    }
                }*/

                const status = (this.Medication.rxStatus ?? "").trim().toUpperCase();

                if (status === 'INACTIVE' && this.Medication.stopDateTime) {

                    await this.getDateTimeValidateStopDate();

                    const stopDate = moment(this.Medication.stopDateTime, Utils.getDateTimeFormat());
                    const now = moment(this.DateNow, Utils.getDateTimeFormat());

                    if (stopDate.isBefore(now)) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Medication.TheStopDateMustBeGreaterThanTheCurrentDate'),
                            "error"
                        );
                        return false;
                    }
                }

                if(this.PharmacyOption.enforceDiagnosis && (!this.Medication.diagCode || this.Medication.diagCode.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceDiagnosisMessage'),"error");        
                    return false;
                }

                if(this.PharmacyOption.enforceSigAction && (!this.Medication.action || this.Medication.action.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceSigActionMessage'),"error");        
                    return false;
                }

                if(this.PharmacyOption.enforceSigRoute && (!this.Medication.route || this.Medication.route.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceSigRouteMessage'),"error");        
                    return false;
                }

                if(this.PharmacyOption.enforceSigReasonPRN && this.frecuencyMode === 'PRN' && (!this.Medication.reason || this.Medication.reason.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceSigReasonPRNMessage'),"error");        
                    return false;
                }
              


               /* if (this.IsNullOrEmpty(this.Medication.drugCode)){
                    this.isDrugValid = false;
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DrugCodeCannotBeEmpty'),"error");        
                    return false;
                }   */      

                if(  ((this.Medication.rxStatus??"").trim().toUpperCase() !== 'INACTIVE') || (this.Medication.rxStatus??"").trim().toUpperCase() !== 'VOID'  ){
                
                    if(this.IsNullOrEmpty(this.Medication.patientCode)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.PatientCodeCannotBeEmpty'),"error");        
                       return false;
                    }

                   /* if(this.IsNullOrEmpty(this.ModelPrescriber.code)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.PrescriberCannotBeEmpty'),"error");
                        this.isPrescriberValid = false;        
                       return false;
                    }*/

                    if(this.IsNullOrEmpty(this.Medication.usage)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageCannotBeEmpty'),"error");        
                        return false;
                    }

                    if( ((this.Medication.usage??"").trim().toUpperCase() !== 'INTERNAL') && (this.Medication.usage??"").trim().toUpperCase() !== 'HOME'){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageMustBeInternalOrHome'),"error");        
                        return false;
                    }
/*
                    if((this.Medication.day??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DaysMustBeGreaterThan0'),"error");  
                        this.isDayValid = false;       
                        return false;
                    }

                    if((this.Medication.dosage??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DosageMustBeGreaterThan0'),"error");   
                        this.isDosageValid = false;       
                        return false;
                    }

                    if((this.Medication.dailyAmount??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DailyAmountMustBeGreaterThan0'),"error");  
                        this.isDailyAmountValid = false;        
                        return false;
                    }*/

                    if((this.Medication.quantityOrdered??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.TotalQuantityMustBeGreaterThan0'),"error");        
                        return false;
                    }

                   /* if(this.IsNullOrEmpty(this.startDateTime)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.StartDateAndTimeCannotBeEmpty'),"error");  
                        this.isStartTimeValid = false;      
                        return false;
                    }

                    if(this.IsNullOrEmpty(this.endDateTime)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EndDateAndTimeCannotBeEmpty'),"error");   
                        this.isEndTimeValid = false;      
                        return false;
                    }*/

                    if(this.IsNullOrEmpty(this.Medication.rxStatus)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.RxStatusCannotBeEmpty'),"error");        
                        return false;
                    }

                   /* if(this.IsNullOrEmpty(this.Medication.frequencyCode)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.FrequencyCodeCannotBeEmpty'),"error");  
                        this.isFrequencyValid = false;      
                        return false;
                    }*/
                }

                return true;
        },

        ValidateRequired(){
            this.isDrugValid = this.IsNullOrEmpty(this.Medication.drugCode) ? false : true;
            this.isPrescriberValid = this.IsNullOrEmpty(this.ModelPrescriber.code) ? false : true;
            this.isFrequencyValid = this.IsNullOrEmpty(this.Medication.frequencyCode) ? false : true;
            this.isDayValid = this.Medication.day <= 0 ? false : true;
            this.isDosageValid = this.Medication.dosage <= 0 ? false : true;
            this.isDailyAmountValid = this.Medication.dailyAmount <= 0 ? false : true;
            this.isStartTimeValid = this.startDateTime ? true : false;
            this.isEndTimeValid = this.endDateTime ? true: false;


            if(this.PharmacyOption.enforceDiagnosis){
                if(!this.Medication.diagCode){
                    this.isDiagnosisValid = false;
                }else{
                    this.isDiagnosisValid = true;
                }
            }else{
                 this.isDiagnosisValid = true;
            }

            if(this.PharmacyOption.enforceSigAction){
                if(!this.Medication.action){
                    this.isActionValid = false;
                }else{
                    this.isActionValid = true;
                }
            }else{
                 this.isActionValid = true;
            }

            if(this.PharmacyOption.enforceSigRoute){
                if(!this.Medication.route){
                    this.isRouteValid = false;
                }else{
                    this.isRouteValid = true;
                }
            }else{
                 this.isRouteValid = true;
            }

            if(this.PharmacyOption.enforceSigReasonPRN && this.frecuencyMode === 'PRN'){
                if(!this.Medication.reason){
                    this.isReasonValid = false;
                }else{
                    this.isReasonValid = true;
                }
            }else{
                 this.isReasonValid = true;
            }

            

            this.TextDrugs = this.Medication.drugCode === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidDrug');
            this.TextFrequency = this.Medication.frequencyCode === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidFrequency');


            return this.isDrugValid && this.isPrescriberValid && this.isFrequencyValid && this.isDayValid && this.isDosageValid && this.isDailyAmountValid && this.isStartTimeValid && this.isEndTimeValid;
            
        },

        isVoidOrInactive() {
            return this.Medication.rxStatus == 'Inactive' || this.Medication.rxStatus == 'Void'
        },

        async ClickOffRoute(){
         this.OffRoute = true;       
         await this.SaveOrEdit();
      },

      async DoAction(){      
            if(this.pendingChanges){
                if(this.Mode) {
                    let savedPrescription = {
                        internalStatus : this.Medication.internalStatus,
                        mode: this.Medication.mode,
                        usage: this.Medication.usage
                    }
                    await MedicationService
                            .get( this.$route.params.recId )
                            .then((response) => {
                                if(response.status == '200' && response.data){ 
                                    const medication = response.data   
                                    savedPrescription.internalStatus = medication.internalStatus;
                                    savedPrescription.mode = medication.mode;
                                    savedPrescription.usage = medication.usage;
                                }
                            });
                    if ( ( (this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') && 
                         ( !this.PharmacyOption.inactivePrescAtAnyStatus) && 
                         (  ( (savedPrescription.internalStatus??"").trim().toUpperCase() == 'MARSCREATED' )  || 
                            ( ((savedPrescription.mode??"").trim().toUpperCase() === "PRN") || ((savedPrescription.internalStatus??"").trim().toUpperCase() === "RECEIVED")
                                && ((savedPrescription.usage??"").trim().toUpperCase() === "INTERNAL")    )
                         ) == false
                       )
                    {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.InactiveStatusMARSCREATED'),"error");        
                        return;
                    } else if( ((this.Medication.rxStatus??"").trim().toUpperCase() === 'VOID') && ((savedPrescription.internalStatus??"").trim().toUpperCase() !== "ORDERED")){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.VoidWhenStatusIsNotORDERED'),"error");        
                        return;
                    }
                }               
            }
           
            if(this.ValidateRequired()){
                await this.getPrescriptionCurrent('WRITE');              
                 const isValid = await this.Validate();               
                    if (!isValid) return;

                this.WasSaved = true;    
                !this.Mode ? this.AddMedication() : this.UpdateMedication(); 
            }else{                
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide"); 
                this.$route.router.go('/');              
            }
            
        },

        async SaveOrEdit(){ 
            if (this.isReadOnly == false && this.pendingChanges) {
                if (this.PharmacyOption && this.PharmacyOption.copyActivePresc && !this.isVoidOrInactive()){                
                    if (this.IsPrescriptionCurrent) {
                        this.$bvModal.msgBoxConfirm(this.$t('Medication.MsgPrescriptionCurrent'), {
                                title: this.$t('Medication.Medications'),
                                okTitle: this.$t('Shared.Continue'),
                                cancelTitle: this.$t('Shared.BtnCancel'),
                                footerClass: 'p-2',
                                titleClass: 'modal-title modal-type-warning',
                                id:'modal_delete_vitals'
                            })
                            .then(value => {
                                if(value) {
                                    this.DoAction();
                                }
                            })
                    } else {
                        this.DoAction();
                    }
                } else {
                    this.DoAction();
                }
            }
        },

        GotoMedicationList(){
            if (this.isShedulerDB) {
                this.$router.push({
                    name: "appointmentDB-Medications",
                    params: { id: this.$route.params.id || this.PCode, actId: this.$route.params.actId },
                });
            } else {
                if(this.$route.name.includes('Clinical-medications')) {
                    this.$router.push({ name: 'Clinical-Medications', params: { id: this.$route.params.id || this.PCode, recordid: this.$route.params.recordid }});
                }
            }
        },

        GotoNewOrder(orderId) {
            if (this.isShedulerDB) {
                this.$router.push({ name: "Appointments-medications-details", 
                    params: { recId: orderId, actId: this.$route.params.actId } });
            } else {
                this.$router.push({ name: "Clinical-medications-details", params: { recId: orderId } });
            }
        },

        AddMedication(){ 
            this.PrepareMedication();   
            MedicationService
                .add(this.ObjData)
                .then((response) => {
                    if(response.status == '200'){
                        this.Medication = response.data;   
                        this.pendingChanges = false;  
                       
                       if(!this.OffRoute || this.clickBack){
                            this.GotoMedicationList();
                       }
                       
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50); 
                    }                  
                })
                .catch((error) => {             
                    this.showResponseErrorMessage(error);
                }); 
        },

        UpdateMedication(){            
            this.PrepareMedication();
            MedicationService
                .update(this.$route.params.recId, this.ObjData)
                .then((response) => {
                    if(response.status == '200'){                       
                        this.pendingChanges = false; 


                        if(!this.OffRoute || this.clickBack){
                            this.GotoMedicationList();
                        }


                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: "success"
                            })
                        , 50); 
                    }                                  
                })
                .catch((error) => {            
                    this.showResponseErrorMessage(error);
                });
        },

        checkUserAction() {

        },

        HideModalDosageTime(){
            this.VisibleDosageTime = false;
        },

       async RefreshDosageTime(obj){
            this.Medication.marsTimes = obj.marsTimes;
            this.VisibleDosageTime = false;

          //  let stime = Utils.formatTime(obj.EndDateTime, Utils.getDateTimeFormat());
            await this.getDateTimeUpdate();
            let sDate = Utils.formatterDate(this.DateandTimeUpdated, Utils.getShortDateFormat());            
            let sDateTime = moment(sDate+" "+obj.EndDateTime, 'YYYY-MM-DD hh:mm A');

            this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format()); 
            this.getMedQuantityToOrder(); 
            this.getMedSig();
        },

        DosageDifferent(i){
            this.Medication.dosage = i ? 0 : this.Medication.dosage;
        },

        async onCodeConditionOk(result){
            var type = result.FieldName;                  
            this.checkUserAction();
            if(type.indexOf('Frequency')  >= 0 ){
                switch (type) {               
                default:
                    if(result.code){
                        this.frecuencyMode = result.AuxFields[1];                       
                        let fCode = result.code.trim(); 
                        if(result.code.trim() !== this.Medication.frequencyCode){                  
                            if(fCode !== null && fCode !== ""){
                                await this.getMedDrugFrequencyByCode(fCode);
                                
                                if(this.Medication.dailyAmount > 0 && this.Medication.dosage === 0){
                                    this.Medication.dosage = this.Medication.dailyAmount / this.timesPerDay;
                                }
                               
                                this.Medication.dailyAmount = this.Medication.dosage * this.timesPerDay; 
                            }
                        }  

                        this.Medication.frequencyCode = result.code.trim();
                        this.Medication.frequencyDescription = result.description.trim();
                        
                        if (result.AuxFields[1] && result.AuxFields[1] === 'TIMED') {
                            await this.getMarsTimes();
                            if(this.marsTimes.length > 0){
                                await this.PopulateDatesWithMarsTime(this.marsTimes);
                            }

                            this.getMedQuantityToOrder(); 
                            this.getMedSig();
                        } else if(result.AuxFields[1] && result.AuxFields[1] === 'STAT') {
                            await this.PopulateDatesNotTimed();
                            this.marsTimes = [];
                            this.Medication.marsTimes = [];
                            this.Medication.day = 1;
                            this.onChangeDay(1);
                           
                        } else {       
                            this.marsTimes = [];
                            this.Medication.marsTimes = [];
                           await this.PopulateDatesNotTimed();
                            this.getMedQuantityToOrder(); 
                            this.getMedSig();
                           
                        }                        
                    }else{
                        this.Medication.frequencyCode = "";
                        this.Medication.frequencyDescription = "";                        
                    }
                }
            }
            else if(type.indexOf('Drugs')  >= 0 ){
                switch (type) {               
                default:
                    if(result.code){                        
                        let dCode = result.code.trim();                     
                        if(result.code.trim() !== this.Medication.drugCode){
                            await this.getMedDrugInfo(dCode);                    
                            this.getMedSig();

                            if(this.Medication.dailyAmount > 0 && this.Medication.dosage === 0){
                                this.Medication.dosage = this.Medication.dailyAmount / this.timesPerDay;
                            }
                            
                            this.Medication.dailyAmount = this.Medication.dosage * this.timesPerDay; 

                            if(this.Medication.day !== 0){
                                if(this.Medication.day > 0 && this.Medication.day !== "" && this.Medication.day !== null){
                                    let stime = Utils.formatTime(this.endDateTime, Utils.getDateTimeFormat());
                                    let sDate = Utils.formatterDate(this.startDateTime, Utils.getDateTimeFormat());
                                    let sDateTime = moment(sDate+" "+stime, 'YYYY-MM-DD hh:mm A').add(this.Medication.day-1, 'd');

                                    this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format()); 
                                }else{
                                    this.endDateTime = this.startDateTime;
                                }    
                            } 

                            if (this.frecuencyMode === 'TIMED') {
                                await this.getMarsTimes();
                            }

                            this.getMedQuantityToOrder(); 
                        }  
                        this.Medication.drugCode = result.code.trim();
                        this.Medication.drugName = result.description.trim();                                     
                    }else{
                        this.Medication.drugCode = "";
                        this.Medication.drugName = "";
                    }
                }
            }
        },

        async getDateTimeUpdate() {         
            await GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {
                        this.DateandTimeUpdated = Utils.formatterDateTimeToString(response.data);                     
                    }                     
                })
                .catch(error => {                  
                   this.showResponseErrorMessage(error);                  
                }); 
        },

       async PopulateDatesNotTimed(){
            await this.getDateTimeUpdate();
            let et = this.DateandTimeUpdated ? this.DateandTimeUpdated.split(" ") : null;
            let etime = et !== null ? et[0]+" 11:59 PM" : this.DateandTimeUpdated;   
            this.startDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(this.DateandTimeUpdated, Utils.getDateTimeFormat()));           
            let fullendTime = moment(Utils.formatDateTime(etime, Utils.getDateTimeFormat())).add(this.Medication.day-1, 'd');  
            this.endDateTime = Utils.formatterDateTimeToString(fullendTime);
        },

       async PopulateDatesWithMarsTime(arr){     
        await this.getDateTimeUpdate();
           // if(this.CopyDateTime){
                let hourNow = Utils.formatTime(this.DateandTimeUpdated, Utils.getDateTimeFormat());     
                let _starttime = hourNow;
                let _endtime = "";

                let st = this.startDateTime ? this.startDateTime.split(" ") : null;
                let et = this.endDateTime ? this.endDateTime.split(" ") : null;

                for (const time of arr) { 
                    if((st !== null && moment(st[0], Utils.getShortDateFormat()) > moment(this.DateandTimeUpdated, Utils.getShortDateFormat())) || 
                        moment(hourNow, 'hh:mm A') < moment(time.adminTime, 'HH:mm')){
                        _starttime = Utils.formatTime(time.adminTime, 'HH:mm');
                        break;
                    }
                } 
                _endtime = Utils.formatTime(arr[arr.length - 1].adminTime, 'HH:mm');  
                
                let stime = st !== null ? st[0]+" "+_starttime : this.DateandTimeUpdated;
                let etime = et !== null ? et[0]+" "+_endtime : this.DateandTimeUpdated;

                this.startDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(stime, Utils.getDateTimeFormat()));
                this.endDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(etime, Utils.getDateTimeFormat()));
           // }
        },

        async getMedDrugInfo(dCode) {            
            if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat())){
                if(Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    await MedicationService
                    .getDrugInfo(dCode,this.Medication.frequencyCode,this.Medication.dailyAmount,
                        Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()), Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()))
                    .then((response) => {      
                        if (response.data) {  
                            this.Medication.day = response.data.day;
                            this.Medication.dosage = response.data.dosage;
                            this.Medication.quantityOrdered = response.data.quantityOrdered;                
                            this.unitOfMeasure = " ( "+response.data.unitOfMeasure+" ) ";
                            this.Medication.restrictChangeDay = response.data.restrictChangeDay;

                            this.ModelAction.code = response.data.actionCode;
                            this.ModelAction.description = response.data.actionDescription;
                            this.Medication.action = this.ModelAction.code;

                            this.ModelRoute.code = response.data.routeNameCode;
                            this.ModelRoute.description = response.data.routeNameDescription;
                            this.Medication.route = this.ModelRoute.code;

                            this.ModelWhen.code = response.data.whenSigCode;
                            this.ModelWhen.description = response.data.whenSigDescription;
                            this.Medication.whenSig = this.ModelWhen.code;

                            this.ModelReason.code = response.data.reasonCode;
                            this.ModelReason.description = response.data.reasonDescription;
                            this.Medication.reason = this.ModelReason.code;
                        }                         
                    })
                    .catch(error => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }                       
                    }); 
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
                }
            
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
            }
        },

        getMedQuantityToOrder() {

            if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat())){
                if(Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    this.SeparateList();
                    let params = {
                        DrugCode:this.Medication.drugCode,
                        FreqCode:this.Medication.frequencyCode,
                        DailyAmount:this.Medication.dailyAmount,
                        SDTime:Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                        EDTime:Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                        Day:this.Medication.day,
                        MarsAdminTime:this.MarsAdminTime,   
                        MarsDosage:this.MarsDosage,   
                    }    
                    MedicationService
                        .getQuantityToOrder(params)
                        .then((response) => {      
                            if (response.status === 200) {                   
                                this.Medication.quantityOrdered  = response.data;
                            } 
                        })
                        .catch(error => {                          
                            this.showResponseErrorMessage(error);
                        }); 
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
                }
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
            }


        },

        SeparateList(){
            this.MarsAdminTime = [];
            this.MarsDosage = [];
            for(var i = 0; i < this.Medication.marsTimes.length; i++ ){
                this.MarsAdminTime.push(this.Medication.marsTimes[i].adminTime);
                this.MarsDosage.push(this.Medication.marsTimes[i].dosage);
            }
        },

        getMedSig() {            
            this.SeparateList();       
            let params = {
                DrugCode:this.Medication.drugCode,
                FreqCode:this.Medication.frequencyCode,
                Day:this.Medication.day,
                Dosage:this.Medication.dosage,
                DailyAmount:this.Medication.dailyAmount,
                Action:this.ModelAction.code,
                Route:this.ModelRoute.code,
                WhenSig:this.ModelWhen.code,
                Reason:this.ModelReason.code,
                MarsAdminTime:this.MarsAdminTime,
                MarsDosage:this.MarsDosage,
            }
            MedicationService
                .getSig(params)
                .then((response) => {      
                    if (response.data) {                   
                        this.Medication.sig  = response.data.sig?.toString();
                        this.Medication.sigTranslated = response.data.sigTranslated?.toString();
                    }                     
                })
                .catch(error => {                    
                    this.showResponseErrorMessage(error);
                }); 
        },       

        ChangeDropDownPrescriber(item){              
            if(item !== null){
                this.ModelPrescriber = item;
                this.Medication.prescriberCode = item.code;
            }else{
                this.ModelPrescriber = {code:"",name:""};
                this.Medication.prescriberCode = "";
            }           
        },

        ChangeDropDownIndication(item){            
            if(item !== null){
                this.ModelIndication = item;
                this.Medication.indicationCode = item.code;           
            }else{
                this.ModelIndication = {code:"",description:""};
                this.Medication.diagCode = "";
            }           
        },

        ChangeDropDownUsage(item){
            if(item !== null){
                this.Medication.usage = item.value;
            }else{
                this.Medication.usage = "";
            }
        },
        
        onChangeShowNoEndDate(){

        },

        async ChangeDropDownRxStatus(item){
            if(item !== null){                
                let savedPrescription = {
                    internalStatus : this.Medication.internalStatus,
                    mode: this.Medication.mode,
                    usage: this.Medication.usage
                }
                if(this.Mode){
                await MedicationService
                        .get(this.$route.params.recId )
                        .then((response) => {
                            if(response.status == '200' && response.data){ 
                                const medication = response.data   
                                savedPrescription.internalStatus = medication.internalStatus;
                                savedPrescription.mode = medication.mode;
                                savedPrescription.usage = medication.usage;
                            }
                        })
                        .catch(error => {                           
                            this.showResponseErrorMessage(error);                          
                        }); 
                }


               
                if  (   ((item.value ?? "").trim().toUpperCase() == "INACTIVE") &&
                        (!this.PharmacyOption.inactivePrescAtAnyStatus) &&
                        (
                            (
                                (   (savedPrescription.internalStatus??"").trim().toUpperCase() == 'MARSCREATED' ) ||
                                (   
                                    ((savedPrescription.mode??"").trim().toUpperCase() === "PRN") && 
                                    ((savedPrescription.internalStatus??"").trim().toUpperCase() === "RECEIVED") && 
                                    ((savedPrescription.usage??"").trim().toUpperCase() === "INTERNAL")
                                )
                            ) == false
                        )
                    ) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.InactiveStatusMARSCREATED'), "error"); 
                        this.Medication.rxStatus = "Active";                        
                        return;
                } else if ( ((item.value ?? "").trim().toUpperCase() == "VOID") &&
                            ((savedPrescription.internalStatus??"").trim().toUpperCase() !== "ORDERED")
                            ) {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.VoidWhenStatusIsNotORDERED'),"error");    
                    this.Medication.rxStatus = "Active";                   
                    return;     
                } else if ((item.value ?? "").trim().toUpperCase() == "VOID") {
                    this.Medication.internalStatus = "VOIDED"
                } else if ((item.value ?? "").trim().toUpperCase() == "PAST") {
                    this.Medication.internalStatus = "FULLYGIVEN"
                } else if ((item.value ?? "").trim().toUpperCase() == "INACTIVE") {
                    const now = new Date();
                    this.Medication.stopDateTime = Utils.formatterDateTimeToString(now);
                }

                this.Medication.rxStatus = item.value;
                if (item.value == "Inactive")
                this.getDateTime(true)
            }
            else{
                this.Medication.rxStatus = ""; 
            }           
        },

        onChangePatientOwned(){

        },

        OnBlurDay(item){           
            if(item <= 0){
                this.Medication.day = 1;
            }           
        },

        ChangeDropDownDiagnosis(item){           
            if(item !== null){
                this.ModelDiagnosis = item;
                this.Medication.diagCode = item.code;           
            }else{
                this.ModelDiagnosis = {code:"",description:""};
                this.Medication.diagCode = "";
            }
            this.isDiagnosisValid = this.Medication.diagCode !== '' ? true : false;
        },

        ChangeDropDownReason(item){           
            if(item !== null){
                this.ModelReason = item;
                this.Medication.reason = item.code;
                this.getMedSig();
            }else{
                this.ModelReason = {code:"",description:""};
                this.Medication.reason = "";
            }       
            
            this.isReasonValid = this.Medication.reason !== '' ? true : false;
        },

        ChangeDropDownAction(item){           
            if(item !== null){
                this.ModelAction = item;
                this.Medication.action = item.code;           
                this.getMedSig();
            }else{
                this.ModelAction = {code:"",description:""};
                this.Medication.action = "";
            }   
            
            this.isActionValid = this.Medication.action !== '' ? true : false;
        },

        ChangeDropDownRouteName(item){           
            if(item !== null){
                this.ModelRoute = item;
                this.Medication.route = item.code;
                this.getMedSig();
            }else{
                this.ModelRoute = {code:"",description:""};
                this.Medication.route = "";
            }    
            
            this.isRouteValid = this.Medication.route !== '' ? true : false;
        },

        ChangeDropDownWhen(item){           
            if(item !== null){
                this.ModelWhen = item;
                this.Medication.whenSig = item.code;
                this.getMedSig();
            }else{
                this.ModelWhen = {code:"",description:""};
                this.Medication.whenSig = "";
            }           
        },

        onChangeShowNoStartDate(){

        },       

        async GetAdminTimeByCode(Code){            
            var result = {}; 
            var ListingRequest = {
                Code : Code
            };      
            await DrugFreqSetupDetService
                .getAllByCode(ListingRequest)
                .then((response) => {      
                    if (response.data) {                    
                        result = response.data;      
                    }                    
                })
                .catch(error => {                
                    this.showResponseErrorMessage(error);
                });  
            return result;        
        },

        async GetDispensingInfo(DrugCode){            
            var result = false;        
            await InventoryItemService
                .get(DrugCode)
                .then((response) => {      
                    if (response.data) {                    
                        result = response.data.dispensingQty > 0  && response.data.dispensingCapacity > 0 && response.data.dispensinguom !== "" ? true : false;                                  
                        if(result){
                            this.InventoryItem = response.data;
                        }           
                    } 
                })
                .catch(error => {                   
                    this.showResponseErrorMessage(error);
                });  
            return result;        
        },

        async GetDrugFreqSetupIsTimed(FreqCode){          
            var result = false;        
            await DrugFreqSetupDetService
                .get(FreqCode)
                .then((response) => {      
                    if (response.data != null && response.data.code != "") {                    
                        result = true;    
                    }                    
                })
                .catch(error => {                   
                    this.showResponseErrorMessage(error);
                });  
            return result;        
        },

        async GetDrugFreqSetupRecurEveryDays(Frequency){            
            var result = 0;        
            await DrugFreqSetupHdrService
                .get(Frequency)
                .then((response) => {      
                    if (response.data) {                    
                        result = response.data.recurEveryDays;                               
                    }                     
                })
                .catch(error => {                  
                    this.showResponseErrorMessage(error);
                });  
            return result;        
        },

        DosesBeforeStartTime(){
            var arr = this.Medication.marsTimeList;
            var sum = 0;
            arr.forEach(element => {
                var adt = moment(element.adminTime).format("HH:mm");
                var st = this.Medication.startTime;
                if(adt < st){
                    sum+=element.qty;
                }  
            });
            return sum;
        },

        async getDateTimeValidateStopDate() {       
            await GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {
                        this.DateNow = Utils.formatterDateTimeToString(response.data);
                    }  
                })
                .catch(error => {                   
                    this.showResponseErrorMessage(error);
                }); 
        },


        async getDateTime(onChangeStopDateTime) {           
            await GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {
                        if (onChangeStopDateTime)
                            this.Medication.stopDateTime = Utils.formatterDateTimeToString(response.data); 
                        else {
                            this.CopyDateTime = Utils.formatterDateTimeToString(response.data);              
                            this.startDateTime = Utils.formatterDateTimeToString(response.data); 
                            this.endDateTime = Utils.formatterDateTimeToString(response.data);
                        }
                    }                    
                })
                .catch(error => {                   
                    this.showResponseErrorMessage(error);
                }); 
        },

        async getMedDrugFrequencyByCode(fCode) {           
            await MedicationService
                .getDrugFrequencyByCode(fCode)
                .then((response) => {      
                    if (response.data) {             
                        this.timesPerDay = response.data.timesPerDay;
                    }                     
                })
                .catch(error => {                   
                    this.showResponseErrorMessage(error);
                }); 
        },

        async getDiagnosisByPatientCode() {            
            await PatientService
                .getDiagnosisListByPatientCode(this.$route.params.id || this.PCode)
                .then((response) => {      
                    if (response.data) {             
                        this.DiagnosisList = response.data;
                    }                      
                })
                .catch(error => {                   
                   this.showResponseErrorMessage(error);                   
                }); 
        },

        async getIndicationsList() {            
            await IndicationService
                .getIndications()
                .then((response) => {      
                    if (response.data) {             
                        this.IndicationsList = response.data;
                    }                    
                })
                .catch(error => {                    
                    this.showResponseErrorMessage(error);                 
                }); 
        },

        async onChangeDosage(){  
            this.getMedSig();
            if(this.Medication.frequencyCode !== null && this.Medication.frequencyCode !== ""){
                await this.getMedDrugFrequencyByCode(this.Medication.frequencyCode);   
                this.Medication.dailyAmount = this.Medication.dosage * this.timesPerDay; 
            }else{
                this.Medication.dailyAmount = 0;
            }
            await this.getMarsTimes();
            this.getMedQuantityToOrder();           
        },

        onChangeDay(item){ 
            if(item <= 0){
                this.Medication.day = 1;
            }       
            
            this.getMedSig();
            if(this.Medication.day !== 0){
                if(this.Medication.day > 0 && this.Medication.day !== "" && this.Medication.day !== null) {
                    let stime = Utils.formatTime(this.endDateTime, Utils.getDateTimeFormat());
                    let sDate = Utils.formatterDate(this.startDateTime, Utils.getDateTimeFormat());
                    let sDateTime = moment(sDate+" "+stime, 'YYYY-MM-DD hh:mm A').add(this.Medication.day-1, 'd');
                    this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format());
                } else {
                    this.endDateTime = this.startDateTime;
                }
            } 
            this.getMedQuantityToOrder();                
        },

        async onChangeDailyAmount(){           
            this.getMedSig();
            if(this.Medication.frequencyCode !== null && this.Medication.frequencyCode !== ""){
                await this.getMedDrugFrequencyByCode(this.Medication.frequencyCode);
                this.Medication.dosage = this.Medication.dailyAmount / this.timesPerDay;            
            }else{
                this.Medication.dosage = 0;
            }
            await this.getMarsTimes();   
            this.getMedQuantityToOrder();            
        },

        onChangeStartDateTime(){

            if(this.startDateTime && this.endDateTime){
               
                if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat()) && Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    var date1 = moment(this.startDateTime, Utils.getDateTimeFormat())
                    var date2 = moment(this.endDateTime,Utils.getDateTimeFormat());
                    this.Medication.day = date2.diff(date1,'days')+1; 
                    this.getMedQuantityToOrder();
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
                }
                
            }           
        },

        onChangeEndDateTime(){
            if(this.startDateTime && this.endDateTime){
                if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat()) && Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    var date1 = moment(this.startDateTime,Utils.getDateTimeFormat());
                    var date2 = moment(this.endDateTime,Utils.getDateTimeFormat());
                    this.Medication.day = date2.diff(date1,'days')+1;                
                    this.getMedQuantityToOrder();
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
                }
            }
           
        },

        async getMarsTimes() {          
            await MedicationService
                .getMarsTimes(this.Medication.frequencyCode,this.Medication.dosage,this.Medication.dailyAmount)
                .then((response) => {      
                    if (response.data) {              
                        let marsList = response.data;

                        if(marsList.length > 0){  
                            let arr = [];                  
                            marsList.forEach((item) => {                       
                                arr.push({adminTime:Utils.formatTimeHm(item.adminTime),
                                        dosage:item.dosage                                                           
                                });                                    
                            });

                            this.marsTimes = arr;
                            this.Medication.marsTimes = [...marsList];
                        }
                    }                     
                })
                .catch(error => {                  
                    this.showResponseErrorMessage(error);                   
                }); 
        },

        getDefaultDateTime() { 
            GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {  
                        this.Medication.stopDate = Utils.formatterDate(response.data);
                        this.Medication.stopTime = Utils.formatTimeHm(response.data);
                    }
                })
                .catch(error => {                  
                    this.showResponseErrorMessage(error);
                }); 
        },

        async getMedicationByRecId(){
            if(this.Mode || this.UseInModal){                         
                await MedicationService
                    .get( this.$route.params.recId || this.RecordId )
                    .then((response) => {
                        if(response.status == '200' && response.data){                   
                            var med = response.data;
                            
                            med.dateTimeCreated = Utils.formatterDateTimeToString(med.dateTimeCreated);  
                            med.endTime = Utils.formatTimeHm(med.endTime);
                            med.startTime = Utils.formatTimeHm(med.startTime);
                            med.endDate = Utils.formatterDate(med.endDate);
                            med.startDate = Utils.formatterDate(med.issuedDate);
                            med.stopDate = Utils.formatterDate(med.stopDate);
                            med.stopTime = Utils.formatTimeHm(med.stopTime);

                            med.startDateTime = Utils.formatterDateTimeToString(med.startDateTime); 
                            med.endDateTime = Utils.formatterDateTimeToString(med.endDateTime); 

                            med.stopDateTime = Utils.formatterDateTimeToString(med.stopDateTime); 
                            
                            this.CopyDateTime = med.startDateTime; 
                            this.startDateTime = med.startDateTime; 
                            this.endDateTime = med.endDateTime; 
                        
                            if(med.marsTimes.length > 0){  
                                let arr = [];                  
                                med.marsTimes.forEach((item) => {                       
                                    arr.push({adminTime:Utils.formatTimeHm(item.adminTime),
                                        dosage:item.dosage                                                             
                                    });                                    
                                });
                                this.marsTimes = arr;
                            }

                            this.ModelAction.code = med.actionCode;
                            this.ModelAction.description = med.actionDescription;

                            this.ModelRoute.code = med.routeCode;
                            this.ModelRoute.description = med.routeDescription;

                            this.ModelWhen.code = med.whenSigCode;
                            this.ModelWhen.description = med.whenSigDescription;

                            this.ModelReason.code = med.reasonCode;
                            this.ModelReason.description = med.reasonDescription;

                            this.ModelDiagnosis.code = med.diagCode;
                            this.ModelDiagnosis.description = med.diagDescription;

                            this.ModelIndication.code = med.indicationCode;
                            this.ModelIndication.description = med.indicationDescription;

                            this.ModelPrescriber.code = med.prescriberCode;
                            this.ModelPrescriber.name = med.prescriberName; 

                            this.Medication = med;
                            this.Medication.action = med.actionCode;
                            this.Medication.reason = med.reasonCode;
                            this.Medication.route = med.routeCode;
                            this.Medication.whenSig = med.whenSigCode;
                          

                            this.frecuencyMode = med.mode;
                            this.isSigned = med.isSigned;

                            this.unitOfMeasure = " ( "+med.unitOfMeasure+" ) ";

                            this.CreatedBy = this.$t('Medication.CreatedBy') +': '+med.employeeName+' '+med.dateTimeCreated+  '   ' + '<span class="highlightInTitle blueTitle">'+ this.$t('Medication.internalStatus.'+ this.Medication.internalStatus) +'</span>'  ;  
                        }                        
                    })
                    .catch((error) => {                       
                        this.showResponseErrorMessage(error);
                    });
            }else{
                this.CreatedBy = this.$t('Medication.CreatedBy') +': '+Utils.strToTitleCase(StorageService.getName()) + '   ' + '<span class="highlightInTitle blueTitle">'+ this.$t('Medication.internalStatus.NEW')+'</span>';             
            }
        },

        getPharmacyOptions(){                      
            PharmacyOptions
                .getPharmacyOptions()
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){                
                        this.PharmacyOption = response.data[0];
                    }                  
                })
                .catch((error) => {                   
                    this.showResponseErrorMessage(error);
                });        
        },

        PrescriberExist(code){    
            for(var i = 0; i < this.PrescriberList.length; i++){
                if( this.PrescriberList[i].code &&  this.PrescriberList[i].code.toUpperCase().trim() === code && code.toUpperCase().trim()){
                    return true;
                }
            }
            return false;
        },

        async getPrescribers(){                         
            await MedicationService
                .getPrescribers()
                .then((response) => {
                    if(response.status == '200' && response.data){                        
                        this.PrescriberList = response.data;
                    }                    
                })
                .catch((error) => {                    
                    this.showResponseErrorMessage(error);
                });        
        },

        getRouteName(){          
            var param = {
                CodeType:"ROUTE",
                GroupCreation:"SIG"
            };     
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.RouteNameList = response.data; 
                        this.RouteNameList.forEach(element => {           
                            element.code = element.description;                 
                        });
                    }                   
                })
                .catch((error) => {                   
                    this.showResponseErrorMessage(error);                   
                });        
        },

        getAction(){         
            var param = {
                CodeType:"ACTION",
                GroupCreation:"SIG"
            };     
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ActionList = response.data;    
                        this.ActionList.forEach(element => {           
                            element.code = element.description;                
                        });
                    }                   
                })
                .catch((error) => {                   
                    this.showResponseErrorMessage(error);                  
                });        
        },

        getReason(){           
            var param = {
                CodeType:"REASON",
                GroupCreation:"SIG"
            };     
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ReasonList = response.data;    
                        this.ReasonList.forEach(element => {           
                            element.code = element.description;                
                        });
                    }                   
                })
                .catch((error) => {                   
                    this.showResponseErrorMessage(error);                  
                });        
        },

        getWhen(){            
            var param = {
                CodeType:"WHEN",
                GroupCreation:"SIG"
            };     
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.WhenList = response.data; 
                        this.WhenList.forEach(element => {           
                            element.code = element.description;
                        });        
                    }                   
                })
                .catch((error) => {              
                    this.showResponseErrorMessage(error);                  
                });        
        },

        getOrderType(){   
            var param = {
                CodeType:"ORDERTYPE",
                GroupCreation:null
            };     
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.OrderTypeList = response.data;              
                    }
                })
                .catch((error) => {                    
                    this.showResponseErrorMessage(error);
                });        
        },

        ChangeFilter(m){      
            this.modelFilter = m;
        },

        beforeWindowUnload(e) {
                if (this.pendingChanges) {
                    e.preventDefault()
                    e.returnValue = ''	
                }
        },

        async SendCopyOrder(stopPreviousPresc){
            if (this.PharmacyOption && this.PharmacyOption.copyActivePresc){
                await this.getPrescriptionCurrent(stopPreviousPresc ? 'COPY_DC' : 'COPY')
            
                if (this.IsPrescriptionCurrent) {
                    this.$bvModal
                        .msgBoxConfirm(this.$t('Medication.MsgPrescriptionCurrent'), {
                            title: this.$t('Medication.Medications'),
                            okTitle: this.$t('Shared.Continue'),
                            cancelTitle: this.$t('Shared.BtnCancel'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning',
                            id:'modal_delete_vitals'
                        })
                        .then(value => {
                            if(value) {
                                this.setCopyOrder(stopPreviousPresc)
                            }
                        })
                } else {
                    this.setCopyOrder(stopPreviousPresc)
                }
            } else {
                    this.setCopyOrder(stopPreviousPresc)
            }
        },

        setCopyOrder(stopPreviousPresc) {
            const params = {
                "oldRecordID": this.$route.params.recId,
                //"admissionRecordID": this.isShedulerDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                 "admissionRecordID": this.isShedulerDB ? null : this.$route.params.recordid,
                "stopPreviousPresc": stopPreviousPresc
            }
            MedicationService
                .CopyOrdeer(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.showMessage(this.$t('Medication.Medications'),this.$t('Medication.MsgOrderCopied'));
                        const orderId = response.data;
                        setTimeout(() => {
                            this.GotoNewOrder(orderId);
                        }, 50)
                    }               
                })
                .catch((error) => { 
                    this.showResponseErrorMessage(error);
                }); 
        },

        InactiveOrders() {
            const params = {
                "recordIDList": [ this.$route.params.recId ]
            }            
            MedicationService
                .InactiveOrders(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.GotoMedicationList();
                        
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Medication.MsgOrderInactive'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50); 
                    }                     
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                }); 
        },

        CopyOrder() {          
            this.SendCopyOrder(false)
        },

        CopyDCOrder() {          
            this.SendCopyOrder(true)
        },

        onChangeStopDateTime() {
            
        },

        setUsageDefault() {
            if (this.RegistrationInfo && this.RegistrationInfo.status == 'Inactive') 
                this.Medication.usage = 'Home'
            else if (this.RegistrationInfo && this.RegistrationInfo.status == 'Active' &&  this.RegistrationInfo.isInpatient == 'Y')
                this.Medication.usage = 'Internal'
            else
                this.Medication.usage = 'Home'
        },

        closeParamRepWindow() {
            this.isReportVisible = false
            this.recNoToReport = ''
        },

        async getPrescriptionCurrent(Action) {
            const params = {
                "PatientCode": this.$route.params.id || this.PCode,  
                "DrugCode": this.Medication.drugCode,
                "Mode":  !this.Mode ? this.frecuencyMode : this.Medication.mode, 
                "RecordId": this.$route.params.recordid, 
                "Action": Action, 
                "StartDateTime": !this.Mode ? Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()) : Utils.formatterToISO(this.Medication.startDateTime, Utils.getDateTimeFormat()), 
                "EndDateTime": !this.Mode ? Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()) : Utils.formatterToISO(this.Medication.endDateTime, Utils.getDateTimeFormat()),
                "Day": this.Medication.day,
            }

            await MedicationService
                    .IsPrescriptionCurrent(params)
                    .then((response) => {
                        if(response.status == '200'){
                            this.IsPrescriptionCurrent = response.data 
                        }               
                    })
                    .catch((error) => { 
                        this.showResponseErrorMessage(error);
                    });

        },

        async getDefaultDoctor() {
            await PatientService
                    .getDefaultDoctor(this.$route.params.id || this.PCode)
                    .then((response) => {
                        if(response.status == '200'){
                            this.defaultDoctor = response.data;

                            if(this.PrescriberExist(this.defaultDoctor.doctorCode)){
                                this.ModelPrescriber.code = this.defaultDoctor.doctorCode;
                                this.ModelPrescriber.name = this.defaultDoctor.doctorName;
                            }
                        }                 
                    })
                    .catch((error) => { 
                        this.showResponseErrorMessage(error);
                    });
        },

        async setDefaultDoctor() {
            if (this.PharmacyOption && this.PharmacyOption.usePatientDoctorAsPrescriber) {
                await this.getDefaultDoctor()
            } else {
                if(this.PrescriberExist(this.$store.state.employeeCode)) {
                    this.ModelPrescriber.code = this.$store.state.employeeCode;
                    this.ModelPrescriber.name = Utils.strToTitleCase(StorageService.getName());
                }       
            }
        },

        setVisibilityInactiveOrder() {
            let visibility = false;
            if (this.Mode && this.Medication.rxStatus != 'Inactive')
                if (this.Medication.internalStatus == 'MARSCREATED' || this.PharmacyOption.inactivePrescAtAnyStatus)
                    visibility = true
            
            return visibility
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`  
        },

        async GetPatientByCode(){
            let infoList = await this.getInfoTitle(this.$route.params.id || this.PCode);
            if(infoList.length > 0){
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;     
            }
        },

        onSignature(value){  
            this.TypePassWord = 'Sign';       
            this.EmployeeCodeSelected = this.ModelPrescriber.code;
            this.showSignPassword = value;
        },

        onModalPasswordResult(result) {
            if(result.type === 'Sign'){
                if(result.Event === "Ok"){
                    if(result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'),result.message,"error");   
                        this.isSigned = false;                  
                    }                  
                } else {
                    this.isSigned = false;
                }  
            }
            this.showSignPassword = false;
        },

    async getProvider(){
      await ProviderService.get(this.$store.state.providerCode)
            .then((response) => {      
               if (response.status == '200' && response.data) { 
                  this.useMerative = response.data.useMerative;            
               }  
         })
         .catch(error => {       
            this.showResponseErrorMessage(error);                 
         });    
    },



        getEmployeeProvider(){
            const UserId = LocalStorage.getUserId();
            EmployeeService
                .GetByUserId(UserId)
                .then((response) => { 
                    if(response.data){             
                        let result = response.data;                    
                        if (result && result.code && this.EmployeeCode == result.code) {
                            this.ProviderModel.therapistCode = this.EmployeeCode;
                            this.ProviderModel.therapistName = LocalStorage.getName();
                            this.ProviderModel.requestSigCreateMed = result.requestSigCreateMed;
                        }
                    }             
                })
                .catch((error) => {                  
                    this.showResponseErrorMessage(error);
                });
        },
    },

    async mounted(){ 
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);    
        this.isShedulerDB = this.$route.name.includes('Appointments-medications-add') || this.$route.name.includes('Appointments-medications-details');

        this.PatientCode =  this.$route.params.id || this.PCode;
        this.AdmissionRecId = !this.isShedulerDB ? this.$route.params.recordid:null;

        let usageIsReadOnly = true;
        let usage = 'Home';
        if (this.isShedulerDB) {
            await this.getCurrentAppointment()
            await this.GetPatientByCode();
            
            if (this.currentAppointmentDB && this.currentAppointmentDB.admissionRecordId) {
                this.RegistrationInfo = await this.getRegistrationInfoTitle(this.currentAppointmentDB.admissionRecordId);
            }
        } else { 
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	
            if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
        }
        await this.getPrescribers();
        await this.getMedicationByRecId();
        if (this.RegistrationInfo && this.RegistrationInfo.recordId) {
            const { allowInternalPrescriptions, dateTo, isInpatient } = this.RegistrationInfo;
            const isActive = dateTo == null;

            if (isActive && (isInpatient == 'Y' || (isInpatient == 'N' && allowInternalPrescriptions))) {
                usageIsReadOnly = false;
                usage = 'Internal';
            }
        }
        
        this.usageIsReadOnly = usageIsReadOnly;
        if(!this.Mode){
            setTimeout(() => {
                this.Medication.rxStatus = "Active";
                this.Medication.usage = usage;
            }, 50, this);
            
            this.getDateTime();
            this.setUsageDefault()
            await this.setDefaultDoctor()
        } else {
           /* setTimeout(() => {
                this.Medication.usage = usage;
            }, 50, this);*/
            this.isReadOnly = !this.Medication.canEdit || this.$store.state.isClinicalMedicationsEHRReadOnly;

            if( (this.Medication.usage === 'Internal') && 
                ( ( !this.PharmacyOption.bypassMedInbox && this.Medication.internalStatus === 'RECEIVED') || this.Medication.internalStatus === 'MARSCREATED')){
                this.internalStatusReadOnly = true;
            }

            if( (this.Medication.usage === 'Home') && 
               ( ( this.Medication.internalStatus !== 'ORDERED' && this.Medication.internalStatus !== 'RECEIVED') || 
                 ( !this.PharmacyOption.bypassMedInbox && this.Medication.internalStatus === 'RECEIVED') )){
                this.internalStatusReadOnly = true;
            }

        }
    },

    async created () {
        this.EmployeeCode = this.$store.state.employeeCode; 
        await this.getPharmacyOptions();

        this.getRouteName();
        this.getAction();
        this.getWhen();
        this.getReason();
        this.getOrderType();
        this.getDiagnosisByPatientCode();
        this.getIndicationsList();
        this.getEmployeeProvider();
        this.getProvider();
        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges = e.Changed; 
            this.checkUserAction();        
        }.bind(this));
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    destroyed(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy () {       
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
} 
</script>